module.exports = __webpack_public_path__ + "static/Axiforma-Black-eabc3e7bf7ba31bc2259f3e9f26ace68.woff2";